import { buildMonetaryDetailSheet, toRows } from "./principle1DetailHelpers";

export const SHEET_NAME = "Settlement";

export function buildSettlementSheet(workbook, sectionC) {
  const essential = sectionC?.principle1?.essentialIndicators || {};
  return buildMonetaryDetailSheet(
    workbook,
    SHEET_NAME,
    "Details of settlement",
    toRows(essential?.monetary?.settlement)
  );
}
